'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.setTheme = exports.getTheme = exports.initializeTheme = exports.THEME_KEY = void 0;
var storage_1 = require("./storage");
/**
 * Key for theme storage.
 */
exports.THEME_KEY = 'dark';
/**
 * Sets the initial theme.
 */
function initializeTheme() {
    setTheme(getTheme());
}
exports.initializeTheme = initializeTheme;
/**
 * Gets the current theme.
 */
function getTheme() {
    return storage_1.getItem(exports.THEME_KEY) ? 'dark' : 'light';
}
exports.getTheme = getTheme;
/**
 * Sets the current theme.
 * @param theme
 */
function setTheme(theme) {
    document.documentElement.dataset.theme = theme;
    storage_1.setItem(exports.THEME_KEY, theme === 'dark');
}
exports.setTheme = setTheme;
